import { pathBuilder } from 'config/paths/index';
export const root = '/admin/request-templates';

// Admin Paths
export default pathBuilder(root);
